

























import { Component, Vue } from 'vue-property-decorator';
import { DxLookup } from 'devextreme-vue';
import notificationService from '@/services/notificationService';
import Popup from '@/components/default/Popup.vue';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxItem,
  DxLabel,
} from 'devextreme-vue/form';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import {
    MeasurementsClient,
    MeasurementMergeCommand,
 } from '@/data/web-api-client';

@Component({
  components: {
    DxPopup,
    DxLookup,
    DxSimpleItem,
    DxGroupItem,
    DxForm,
    DxLabel,
    DxItem,
    DxToolbarItem,
    DxRequiredRule,
    Popup,
  },
})
export default class MeasurementsMergePopup extends Vue {
  public saving: boolean = false;
  public loading: boolean = false;
  public model: MeasurementMergeCommand = new MeasurementMergeCommand({
    projectId: '',
    name: '',
    list: [],
    removeAfterMerge: false,
  });
  public show: boolean = false;

  public hideDialog() {
    this.show = false;
  }

  get form() {
    const form: any = this.$refs.measurementMergeForm;
    return form.instance;
  }

  public async save() {
    try {
      const validationResult = this.form.validate();
      if (validationResult.isValid) {
        this.saving = true;
        const result = await (new MeasurementsClient(undefined, this.$axios))
          .mergeMeasurement(this.model.projectId!, this.model);

        this.$router.push({ path: `/projects/${this.model.projectId}/measurements/${result.replace('/', '-').replace('/', '-')}` });
        notificationService.saved();
        this.hideDialog();
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }
}
